<template>
  <div class="w-full h-full bg-[#151A1F] GameDetail overflow-auto fixed top-0 z-10">
    <withTopNav
      leftText="Detalhes da Conta"
      fixed
      :onClickLeft="
        () => {
          $emit('close');
        }
      "
    >
      <!-- main -->
      <div class="w-full px-[20px] text-[#fff]/45">
        <div class="w-full text-[#fff] mt-6 rounded-[10px]">
          <div class="flex mb-[2px] p-[12px] bg-[#2C7952]/70 rounded-t-[8px]">
            <span class="flex-1 text-[15px] ml-[5px]">{{ $t('Registro.GameDetail.Total') }}</span>
            <div class="flex items-center">
              <span class="text-[13px]">{{ timeRangeText }}</span>
            </div>
          </div>
          <div class="flex justify-between leading-[20px] rounded-[8px]">
            <div
              class="p-[12px] flex-1 flex flex-col justify-center items-center bg-[#2C7952]/40"
            >
              <span class="block mb-[5px] text-[#fff] text-[15px]">{{
                formatter().format(totalBetAmount)
              }}</span>
              <span class="text-[#FFFFFF80]">{{ $t('Registro.GameDetail.BetTimes', { totalBetTimes }) }}</span>
            </div>
            <div
              class="ml-[1px] p-[12px] flex-1 flex flex-col justify-center items-center bg-[#2C7952]/40"
            >
              <span class="block mb-[5px] text-[#fff] text-[15px]">{{
                formatter().format(subtractDecimals(totalBetWinAmount, totalBetAmount))
              }}</span>
              <span class="text-[#FFFFFF80]">{{ $t('Registro.GameDetail.WinOrLose') }}</span>
            </div>
          </div>
        </div>
        <van-list
          v-model:loading="loading"
          :finished="hasMore"
          :loading-text="$t('Common.Loading')"
          finished-text="Não há mais dados"
          @load="getList"
        >
          <div
            v-for="item in detailsList"
            :key="item.id"
            class="w-full bg-[#2C7952]/40 p-[10px] rounded-[10px] mt-[10px] flex items-center"
          >
            <Image class="size-[51px]" :src="item.icon" alt="" />
            <div class="flex-1 px-[10px] flex flex-col gap-[5px]">
              <div class="flex justify-between items-center text-[#fff]">
                <span>{{ item.name }}</span>
                <div class="flex items-center gap-[5px]">
                  <span
                    class="text-[15px]"
                    :style="{
                      color: item.winLoss > 0 ? '#0BCF33' : '#FF3B30',
                    }"
                  >
                    {{ item.winLoss > 0 ? `+${item.winLoss}` : `${item.winLoss}` }}
                  </span>
                </div>
              </div>
              <div class="flex justify-between items-center text-[#FFFFFFBF]">
                <span>Faturamento {{ formatter().format(item.betAmount) }}</span>
                <span>{{ dayjs(item.settleTime).format("YYYY-MM-DD HH:mm") }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </withTopNav>
  </div>
</template>

<script setup lang="ts">
import { getDetailRecordList } from "@/api/registro";
import { subtractDecimals } from "./../main";
import { formatter } from "@/utils";
// import { options } from "./../constants";
import dayjs from "dayjs";
import withTopNav from "@/layouts/withTopNav.vue";
import i18n from "@/i18n";
const t = i18n.global.t;
import { getLabel } from "./../constants";
const { options } = getLabel(t);
const props = defineProps({
  gameItem: Object,
});

const emit = defineEmits(["close"]);
const hasMore = ref(false);
const current = ref(0);
const detailsList = ref<any[]>([]);
const loading = ref(false);

const {
  timeRange,
  timeRangeObj,
  totalBetAmount,
  totalBetWinAmount,
  totalBetTimes,
  gameCode,
} = props.gameItem as any;

const timeRangeText = options.find((item) => item.values === timeRange)?.text;

const getList = async () => {
  loading.value = true;
  const res = await getDetailRecordList({
    startTime: timeRangeObj?.startTime,
    endTime: timeRangeObj?.endTime,
    gameCode,
    pageSize: 10,
    pageIndex: current.value++,
  });
  detailsList.value = [...detailsList.value, ...res.data.data];
  hasMore.value = detailsList.value.length >= Number(res.data.total);
  loading.value = false;
};
</script>

<style scoped></style>
